export default function Badge({ children, variant = 'gold' }) {
  return <span className={`badge badge-${variant}`}>{children}</span>;
}
